import { render, staticRenderFns } from "./VerificationPage.vue?vue&type=template&id=46bddf16&"
import script from "./VerificationPage.vue?vue&type=script&lang=js&"
export * from "./VerificationPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports